import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import './RoomCode.scss';
import { useTranslation } from 'react-i18next';
import { ROOM_STATUS } from 'shared/constants';
import ChevronDown from 'assets/svgs/chevronDown.svg';
import ChevronUp from 'assets/svgs/chevronUp.svg';
import { AlertNotice } from 'shared/components';

const RoomCode = (props) => {
  const { t } = useTranslation();
  const { code, roomStatus, testCenterCode } = props;

  const [isExpanded, setIsExpanded] = useState(true);
  const [message, setMessage] = useState(t('onlineTesting.roomCode.closedRoom'));

  if (!code && roomStatus === ROOM_STATUS.opened) {
    setMessage(t('onlineTesting.roomCode.noCode'));
  }

  const setExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (roomStatus === ROOM_STATUS.closed) {
    return null;
  }

  return (
    <Collapsible
      open={isExpanded}
      trigger={
        <div className="header-container" onClick={setExpand}>
          <div className="title">{t('onlineTesting.roomCode.roomCode')}</div>
          <div className="status">
            <div className="title">{isExpanded ? 'Collapse' : 'Expand'}</div>
            {isExpanded ? <ChevronUp /> : <ChevronDown />}
          </div>
        </div>
      }>
      {roomStatus !== ROOM_STATUS.opened || !code ? (
        <AlertNotice message={message} />
      ) : (
        <div className="codes-container">
          <div className="codes">
            <div className="code">
              {Array.from(`${testCenterCode ? testCenterCode.substring(0, 5) : ''}`).map(
                (seal, i) => (
                  <div className="individual-number" key={i}>
                    {seal}
                  </div>
                )
              )}
              {testCenterCode ? (
                <div className="individual-number individual-number-hyphen">-</div>
              ) : (
                ''
              )}
              {Array.from(`${code}`).map((seal, i) => (
                <div className="individual-number" key={i}>
                  {seal}
                </div>
              ))}
            </div>
            <div className="test">{code.shortName}</div>
          </div>
        </div>
      )}
    </Collapsible>
  );
};

export default RoomCode;

RoomCode.propTypes = {
  code: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      shortName: PropTypes.string,
    }),
  ]),
  roomStatus: PropTypes.string.isRequired,
  testCenterCode: PropTypes.string,
};
